<script setup lang="ts">
import { useOnTimezoneChange } from '@entities/viewer'

import { useOrderShowApi } from '../api/show.hook'
import SectionOrderInfo from './SectionOrderInfo.vue'
import SectionOrderPaymentLog from './SectionOrderPaymentLog.vue'
import ModalOrderPaymentChangelog from './modals/ModalOrderPaymentChangelog.vue'

defineOptions({
  name: 'OrderDetailsPage',
})

const route = useRoute()

// Every order date arrives pre-shifted into the admin's view timezone.
useOnTimezoneChange(() => {
  void useOrderShowApi(route.params.id as string)
})
</script>

<template>
  <div class="orders-show">
    <SectionOrderInfo />
    <SectionOrderPaymentLog />
  </div>
  <ModalOrderPaymentChangelog />
</template>

<style scoped lang="scss" src="./OrderDetailsPage.scss" />
